<script>
    import Fa from 'svelte-fa';
    import { faClose } from '@fortawesome/pro-regular-svg-icons';

    import { fly } from 'svelte/transition';
    import { cubicOut } from 'svelte/easing';
    import { subscribe } from '$lib/utils/pubsub';
    import { siteNotification } from '$lib/utils/notifications/events';

    let notificationMessage;
    let notificationId;

    // pubsub
    subscribe(siteNotification, (message) => {
        notificationMessage = message.length ? message : null;
        if (notificationMessage) closeNotificationTimer(3000);
    });

    // auto close notification after x seconds
    const closeNotificationTimer = (timeToClose) => {
        clearTimeout(notificationId);
        notificationId = setTimeout(() => {
            notificationMessage = null;
        }, timeToClose);
    };
</script>

{#if notificationMessage}
    <div
        class="fixed bottom-0 left-0 z-50 w-full px-4 py-7 lg:left-auto lg:right-0 lg:top-0 lg:max-w-md lg:py-6"
        in:fly={{ easing: cubicOut, y: 100, duration: 300, delay: 200 }}
        out:fly={{ easing: cubicOut, y: 100, duration: 300 }}
    >
        <button
            class="w-full rounded-xl bg-purple-200 p-4 text-base font-medium text-gray-900 shadow-xl"
            on:click={() => {
                notificationMessage = null;
                closeNotificationTimer(3000);
            }}
        >
            <div class="flex items-center justify-center gap-4">
                <div class="grow text-center">
                    <p class="select-none">{notificationMessage}</p>
                </div>
                <div class="text-center">
                    <div><Fa icon={faClose} /></div>
                </div>
            </div>
        </button>
    </div>
{/if}
